import { SpinnerContainer, SpinnerOverlay } from './spiner.styles';

const Spinner = () => (
  <SpinnerOverlay>
    <SpinnerContainer src="https://icons.iconarchive.com/icons/turbomilk/space-invaders/256/blackhole-icon.png" />
  </SpinnerOverlay>
);

export default Spinner;
